export default "__VITE_ASSET__BTfV4mPs__"